import { ToolHumanApproval } from '@common/hooks/useChatbot';
import { axiosErrorMiddleware } from '@requests/common';
import axios from 'axios';

export const executeHttpTool = async (toolApproval: ToolHumanApproval) => {
  try {
    const response = await axios(toolApproval.data);
    return response.data;
  } catch (error) {
    throw new Error(axiosErrorMiddleware(error).error);
  }
};
